import React from 'react';
import { useParams } from 'react-router-dom';
import {
  DocumentSource,
  type ReadExampleQuery,
} from '../../../__generated__/graphql';
import { Button, Col, ListGroup, Row, Stack } from 'react-bootstrap';
import { ReturnLayout } from '../../../Components/ReturnLayout';
import ContentLoader from '../../../Components/ContentLoader';
import { READ_EXAMPLE } from '../../../graphql/queries';

/**
 * Cette vue affiche les détails d'un exemple.
 *
 * @returns La page rendue
 */
export default function ReadExample(): React.ReactElement {
  const { id, exampleId } = useParams();

  /**
   * Assure le rendu du composant une fois les données chargées.
   *
   * @param data Les données qui doivent être rendues
   *
   * @returns Le rendu des données
   */
  const dataPlacement = (
    data: ReadExampleQuery | undefined
  ): React.ReactElement => {
    const example = data?.examples?.items?.at(0);

    // skipcq JS-0424
    if (!example) return <></>;
    return (
      // skipcq JS-0415
      <>
        <Row className="my-3">
          <Col>
            <h2>{example.document.title}</h2>
          </Col>
          <Col md="auto">
            <Stack direction="horizontal" gap={2}>
              <Button
                variant="primary"
                href={example.document.url}
                target="_blank"
              >
                {example.document.source === DocumentSource.File
                  ? 'Télécharger'
                  : 'Consulter'}
              </Button>
              {example.canBeEdited && (
                <Button
                  variant="primary"
                  href={`/indicateurs/${id}/exemples/${exampleId}/modification`}
                >
                  Modifier
                </Button>
              )}
            </Stack>
          </Col>
        </Row>
        <hr />
        <Row className="mb-3">
          <div className="h5">Remarques sur l&apos;exemple</div>
        </Row>
        <Row className="mb-3">
          <p>{example.remark}</p>
        </Row>
        <hr />
        <Row className="mb-3">
          <ListGroup>
            <ListGroup.Item>Titre : {example.document.title}</ListGroup.Item>
            <ListGroup.Item>
              Résumé : {example.document.abstract ?? ''}
            </ListGroup.Item>
            <ListGroup.Item>
              auteur(rice)s : {(example.document.authors ?? []).join(', ')}
            </ListGroup.Item>
            <ListGroup.Item>
              Année de publication : {example.document.publicationYear}
            </ListGroup.Item>
            <ListGroup.Item>
              Ajouté par : {example.owner.firstName}{' '}
              {example.owner.lastName}
            </ListGroup.Item>
          </ListGroup>
        </Row>
      </>
    );
  };

  return (
    <ReturnLayout href={`/indicateurs/${id}`}>
      <Row>
        <Col>
          <ContentLoader
            query={READ_EXAMPLE}
            variables={{ exampleId }}
            // Ceci devrait être ignoré au moment de la suppression d'un exemple.
            // skipcq JS-0417
            data={dataPlacement}
          />
        </Col>
      </Row>
    </ReturnLayout>
  );
}
